export default "__VITE_ASSET__B_kJhE4I__"